<template>
  <component :is="layout" />
</template>

<script>
export default {
  components: {
    default: defineAsyncComponent(
      () => import('./Layouts/Default/SubscribeForm.vue')
    ),
    simple: defineAsyncComponent(
      () => import('./Layouts/Simple/Subscribe.vue')
    ),
  },
  props: {
    layout: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'simple'].includes(value),
    },
  },
};
</script>
